import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteWorkoutTemplate(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteWorkoutTemplate = (workoutTemplateId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`workout-templates/${workoutTemplateId}/`);
  };

  return useMutation(deleteWorkoutTemplate, {
    onSuccess: (_, workoutTemplateId) => {
      queryClient.invalidateQueries('workoutTemplates');
      queryClient.invalidateQueries(['workoutTemplate', workoutTemplateId]);
    },
  });
}
